import axios from "axios";

const getSetting = async () => {
  try {
    const res = await axios.get(`setting`);
    return {
      result: res.data,
      message: "success",
    };
  } catch (error) {
    console.error("Error fetching settings:", error);
  }
};

/** Returns full URL for company logo from settings (logo filename). Use in PDFs/prints. */
export const getLogoUrl = (filename) => {
  if (!filename) return null;
  const base = axios.defaults.baseURL || "";
  return `${base}setting/logo/${filename}`;
};

export default getSetting;